import Chat from 'components/chat/Chat';
import { Route } from 'react-router-dom';
import AlertsPage from 'sites/admin/inmobiliario/gestionarAlertas/AlertsPage';
import Notifications from 'sites/common/Notifications';
import renderConditionalComponent from 'utils/renderConditionalComponent';

const RoutesNotificaciones = () => {
  return (
    <>
      <Route
        path="/alertas"
        element={renderConditionalComponent('Alerts', AlertsPage)}
      />

      <Route
        path="/mensajes"
        element={renderConditionalComponent('Messages', Chat)}
      />

      <Route
        path="/notificaciones"
        element={renderConditionalComponent('Notifications', Notifications)}
      />
    </>
  );
};

export default RoutesNotificaciones;
